import React, {PureComponent} from "react";
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid'
import TextField from 'housecall-ui/dist/DesignSystem/Inputs/TextFields/TextField'
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles'

const styles = theme => ({
    textField: {
        width: '100%'
    },
    textFieldContainer: {
        width: '90%'
    },
});

@withStyles(styles)
export default class CreateUpdateTitle extends PureComponent {
    render() {
        const {classes, title, disabled} = this.props;
        return <Grid item className={classes.textFieldContainer}>
            <TextField
                id="title"
                label="Title"
                placeholder="Enter title"
                autoFocus={true}
                className={classes.textField}
                value={title}
                disabled={disabled}
                onChange={(event) => {
                    this.props.onTitleChange(event.target.value)
                }}
            />
        </Grid>
    }
}
